var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',[_c('button',{staticClass:"footer_download"},[_vm._v("使用Chrome或UC浏览器开启本站获得最佳体验 ")])])])}]

export { render, staticRenderFns }